type Filters = Record<string, string>

const FILTERS_KEY = 'filters'
const FILTERS_REGEX = new RegExp(`^${FILTERS_KEY}\\[(.+)\\]$`)

function parseFiltersFromSearch(search: string): Filters {
  const params = new URLSearchParams(search)
  const result: Filters = {}

  params.forEach((value, name) => {
    const match = name.match(FILTERS_REGEX)

    if (match) {
      result[match[1]] = value
    }
  })

  return result
}

function getFiltersSearchKey(search: string): string {
  const filters = parseFiltersFromSearch(search)

  return Object.entries(filters)
    .sort(([leftId], [rightId]) => leftId.localeCompare(rightId))
    .map(([id, value]) => `${id}=${value}`)
    .join('|')
}

export {FILTERS_KEY, FILTERS_REGEX, getFiltersSearchKey, parseFiltersFromSearch}
export type {Filters}
